<template>
  <div id="home">
    <div v-for="(item, index) in questionList" :key="item.id" v-show="isShow">
      <div v-if="index == page">
        <h2>{{ item.name }}.{{ item.category }}</h2>
        <threeSeletOne
          :item="item"
          v-if="item.type == '三项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></threeSeletOne>
        <fourSelectOne
          :item="item"
          v-if="item.type == '四项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></fourSelectOne>
        <fiveSelectOne
          :item="item"
          v-if="item.type == '五项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></fiveSelectOne>
        <sixSelectOne
          :item="item"
          v-if="item.type == '六项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></sixSelectOne>
        <leftFourSelectOne
          :item="item"
          v-if="item.type == '左右四项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></leftFourSelectOne>
        <leftSixSelectOne
          :item="item"
          v-if="item.type == '左右六项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></leftSixSelectOne>
        <leftFiveSelectOne
          :item="item"
          v-if="item.type == '左右五项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></leftFiveSelectOne>
        <topFourSelectOne
          :item="item"
          v-if="item.type == '上下四项'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></topFourSelectOne>
        <RotatingPicture
          :item="item"
          v-if="item.type == '回答问题'"
          :echo="echo"
          @nextTopic="nextTopic"
        ></RotatingPicture>
        <div class="btnSwitch" v-if="item.name == '练习6/6'">
          <el-button
            type="danger"
            class="next"
            @click="beginTesting(item, index)"
            :class="index == 0 ? 'next' : 'before-next'"
            >开始测试</el-button
          >
          <el-button
            type="warning"
            class="next"
            plain
            @click="showDialog = true"
            :class="index == 0 ? 'next' : 'before-next'"
            >指导手册</el-button
          >
        </div>
        <div class="btnSwitch" v-else>
          <!-- <el-button type="warning">警告按钮</el-button> -->
          <el-button
            type="warning"
            class="back"
            v-show="item.name !== '1/92'"
            @click="toBack(item, index)"
            v-if="index != 0"
            :class="index == 0 ? 'before-back' : 'back'"
            >上一题</el-button
          >
          <el-button
            type="warning"
            class="next"
            @click="toNext(item, index)"
            v-if="isShowBtn"
            :class="index == 0 ? 'next' : 'before-next'"
            >下一题</el-button
          >

          <!-- 提交 -->
          <el-button
            type="danger"
            class="next"
            v-if="!isShowBtn"
            @click="submit(item, index)"
            :class="index == 0 ? 'next' : 'before-next'"
            >提交</el-button
          >

          <!--     -->
          <el-button
            type="warning"
            class="next"
            plain
            @click="showDialog = true"
            :class="index == 0 ? 'next' : 'before-next'"
            >指导手册</el-button
          >
          <el-select
            v-if="
              item.name !== '练习1/6' &&
              item.name !== '练习2/6' &&
              item.name !== '练习3/6' &&
              item.name !== '练习4/6' &&
              item.name !== '练习5/6' &&
              item.name !== '练习6/6'
            "
            v-model="selectValue"
            @change="selectChange"
            @blur="selectBlur(item, index)"
            class="custom-select"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item.label"
            ></el-option>
          </el-select>
        </div>

        <el-dialog :visible="showDialog" v-if="showDialog" @close="btnCancel">
          <p>{{ item.introduction }}</p>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import fourSelectOne from '@/components/fourSelectOne.vue';
import threeSeletOne from '@/components/threeSeletOne.vue';
import fiveSelectOne from '@/components/fiveSelectOne.vue';
import sixSelectOne from '@/components/sixSelectOne.vue';
import leftFourSelectOne from '@/components/left-fourSelectOne.vue';
import leftSixSelectOne from '@/components/left-sixSelectOne.vue';
import leftFiveSelectOne from '@/components/left-fiveSelectOne.vue';
import topFourSelectOne from '@/components/top-fourSelectOne.vue';
import RotatingPicture from '@/components/Rotating-picture.vue';

import {
  scaleList,
  editScaleAnswer,
  updaScaleAnswerSchedule
} from '@/api/login/login.js';
import { mapState } from 'vuex';
//
export default {
  data() {
    return {
      // loading: true,
      questionList: [],
      isShow: true,
      isShowBtn: true,
      page: 0, // 当前页
      // 选项
      radio: '',
      echo: '',
      //存放每一题的id和num
      questionInfos: [],
      // 题目的id
      ids: [],
      // 分数
      nums: [],
      studentId: sessionStorage.getItem('studentIdA'),
      showDialog: false,
      showGrade: false,
      gradeList: {
        answerDate: '',
        score: '0',
        studentAge: ''
      },
      totalTime: '',
      everyTime: '',
      timeShow: '',
      // times: sessionStorage.getItem("times"), //答题次数
      startTime: '', //开始答题计时
      overTime: '', //结束答题计时
      distinction: false,
      isProcessing: null,
      options: [
        {
          value: '1',
          label: '7'
        },
        {
          value: '2',
          label: '8'
        },
        {
          value: '3',
          label: '9'
        },
        {
          value: '4',
          label: '10'
        },
        {
          value: '5',
          label: '11'
        },
        {
          value: '6',
          label: '12'
        },
        {
          value: '7',
          label: '13'
        },
        {
          value: '8',
          label: '14'
        },
        {
          value: '9',
          label: '15'
        },
        {
          value: '10',
          label: '16'
        },
        {
          value: '11',
          label: '17'
        },
        {
          value: '12',
          label: '18'
        },
        {
          value: '13',
          label: '19'
        },
        {
          value: '14',
          label: '20'
        },
        {
          value: '15',
          label: '21'
        },
        {
          value: '16',
          label: '22'
        },
        {
          value: '17',
          label: '23'
        },
        {
          value: '18',
          label: '24'
        },
        {
          value: '19',
          label: '25'
        },
        {
          value: '20',
          label: '26'
        },
        {
          value: '21',
          label: '27'
        },
        {
          value: '22',
          label: '28'
        },
        {
          value: '23',
          label: '29'
        },
        {
          value: '24',
          label: '30'
        },
        {
          value: '25',
          label: '31'
        },
        {
          value: '26',
          label: '32'
        },
        {
          value: '27',
          label: '33'
        },
        {
          value: '28',
          label: '34'
        },
        {
          value: '29',
          label: '35'
        },
        {
          value: '30',
          label: '36'
        },
        {
          value: '31',
          label: '70'
        },
        {
          value: '32',
          label: '38'
        },
        {
          value: '33',
          label: '39'
        },
        {
          value: '34',
          label: '40'
        },
        {
          value: '35',
          label: '41'
        },
        {
          value: '36',
          label: '42'
        },
        {
          value: '37',
          label: '43'
        },
        {
          value: '38',
          label: '44'
        },
        {
          value: '39',
          label: '45'
        },
        {
          value: '40',
          label: '46'
        },
        {
          value: '41',
          label: '47'
        },
        {
          value: '42',
          label: '48'
        },
        {
          value: '43',
          label: '49'
        },
        {
          value: '44',
          label: '50'
        },
        {
          value: '45',
          label: '51'
        },
        {
          value: '46',
          label: '52'
        },
        {
          value: '47',
          label: '53'
        },
        {
          value: '48',
          label: '54'
        },
        {
          value: '49',
          label: '55'
        },
        {
          value: '50',
          label: '56'
        },
        {
          value: '51',
          label: '57'
        },
        {
          value: '52',
          label: '58'
        },
        {
          value: '53',
          label: '59'
        },
        {
          value: '54',
          label: '60'
        },
        {
          value: '55',
          label: '61'
        },
        {
          value: '56',
          label: '62'
        },
        {
          value: '57',
          label: '63'
        },
        {
          value: '58',
          label: '64'
        },
        {
          value: '59',
          label: '65'
        },
        {
          value: '60',
          label: '66'
        },
        {
          value: '61',
          label: '67'
        },
        {
          value: '62',
          label: '68'
        },
        {
          value: '63',
          label: '69'
        },
        {
          value: '64',
          label: '70'
        },
        {
          value: '65',
          label: '71'
        },
        {
          value: '66',
          label: '72'
        },
        {
          value: '67',
          label: '73'
        },
        {
          value: '68',
          label: '74'
        },
        {
          value: '69',
          label: '75'
        },
        {
          value: '70',
          label: '76'
        },
        {
          value: '71',
          label: '77'
        },
        {
          value: '72',
          label: '78'
        },
        {
          value: '73',
          label: '79'
        },
        {
          value: '74',
          label: '80'
        },
        {
          value: '75',
          label: '81'
        },

        {
          value: '76',
          label: '82'
        },
        {
          value: '77',
          label: '83'
        },
        {
          value: '78',
          label: '84'
        },
        {
          value: '79',
          label: '85'
        },
        {
          value: '80',
          label: '86'
        },
        {
          value: '81',
          label: '87'
        },
        {
          value: '82',
          label: '88'
        },
        {
          value: '83',
          label: '89'
        },
        {
          value: '84',
          label: '90'
        },
        {
          value: '85',
          label: '91'
        },
        {
          value: '86',
          label: '92'
        },
        {
          value: '87',
          label: '93'
        },
        {
          value: '88',
          label: '94'
        },
        {
          value: '89',
          label: '95'
        },
        {
          value: '90',
          label: '96'
        },
        {
          value: '91',
          label: '97'
        },
        {
          value: '92',
          label: '98'
        }
      ],
      selectValue: '',
      jump: true,
      last: JSON.parse(sessionStorage.getItem('last'))
    };
  },
  components: {
    fourSelectOne,
    threeSeletOne,
    fiveSelectOne,
    sixSelectOne,
    leftFourSelectOne,
    leftSixSelectOne,
    leftFiveSelectOne,
    topFourSelectOne,
    RotatingPicture
  },
  computed: {
    // 使用 vuex 中 count 的值
    ...mapState(['times'])
  },
  mounted() {},
  created() {
    this.scaleList();
    this.getQuestionInfos();
  },
  // watch: {
  //   $route: {
  //     handler: function(val) {
  //       // console.log(val.query.id);
  //       this.studentId = val.query.id;
  //     },
  //     // 深度观察监听
  //     deep: true,
  //     immediate: true
  //   }
  // },
  methods: {
    // 列表
    async scaleList() {
      let { data } = await scaleList({
        ownershipId: 1
      });
      console.log(data);
      data = data.sort((a, b) => {
        return a.name - b.name;
      });
      this.questionList = data;
    },
    // 是否继续答题 选项
    getQuestionInfos() {
      let res = JSON.parse(sessionStorage.getItem('lastList'));
      if (res) {
        this.questionInfos = res;
        // console.log(this.lastList);
        this.toIndex(this.last.ids + 6);
        // this.page = this.last.ids + 6;
      }
    },
    nextTopic(value) {
      this.radio = value;
    },
    // 总分
    saveCur(item, index) {
      this.questionInfos[index] = {
        ids: index,
        nums: this.radio,
        type: item.type,
        name: item.name
      };
    },

    // 跳到某题目
    toIndex(index) {
      if (this.questionInfos[index]) {
        this.echo = this.questionInfos[index].nums || '';
      } else {
        this.echo = '';
      }
      this.page = index;
      this.radio = '';
    },

    // 点击上一题
    toBack(item, index) {
      console.log(this.questionInfos);
      this.timerStart();
      this.distinction = true;
      // 1、保存当前
      this.saveCur(item, index);
      // 2 显示上一题
      this.toIndex(index - 1);
      this.isShowBtn = true;
    },
    // 下一题
    async toNext(item, index) {
      // if (this.isProcessing !== null) return;
      // this.isProcessing = setTimeout(async () => {
      this.timeOver();
      // 1、保存当前
      this.saveCur(item, index);
      if (this.questionList[index].name) {
        if (this.questionInfos[index].nums) {
          let exName = this.questionList[index].name;
          if (exName.search('练习') != -1) {
            console.log('不上传');
          } else {
            if (!this.questionList[index].amendId) {
              //新增
              let parmas = {
                options: this.questionInfos[index].nums,
                scaleId: this.questionList[index].id,
                studentId: this.studentId,
                scaleName: this.questionList[index].name,
                timeSpent: this.everyTime,
                times: this.times
              };
              const res = await editScaleAnswer(parmas);
              if (res.code == 0) {
                this.questionList[index].amendId = res.data; //♥♥♥♥♥♥
                this.questionList[index].everyTime = this.everyTime; //♥♥♥♥♥♥
              }
            } else {
              //修改
              let parmas = {
                options: this.questionInfos[index].nums,
                scaleId: this.questionList[index].id,
                studentId: this.studentId,
                id: this.questionList[index].amendId,
                scaleName: this.questionList[index].name,
                timeSpent: this.questionList[index].everyTime + this.everyTime,
                times: this.times
              };
              this.questionList[index].everyTime = parmas.timeSpent;

              await editScaleAnswer(parmas);
            }
          }
        }
      }
      //开始计时
      this.timerStart();
      // 2 显示下一题
      this.toIndex(index + 1);
      // this.isProcessing = null;
      // }, 1000);
      if (this.page == this.questionList.length - 1) {
        this.$message.warning('最后一题');
        this.isShowBtn = false;
        return;
      } else {
        return (this.isShowBtn = true);
      }
    },
    // 点击提交
    async submit(item, index) {
      // 1、保存当前
      this.saveCur(item, index);

      console.log(this.questionInfos);
      sessionStorage.setItem(
        'questionInfos',
        JSON.stringify(this.questionInfos)
      );
      this.conversionTime();
      if (this.questionList[index].name) {
        let exName = this.questionList[index].name;
        if (exName.search('练习') != -1) {
          console.log('不上传');
        } else {
          if (this.questionInfos[index].nums) {
            let parmas = {
              options: this.questionInfos[index].nums || 'M',
              scaleId: this.questionList[index].id,
              studentId: this.studentId,
              scaleName: this.questionList[index].name,
              answerTime: this.timeShow,
              timeSpent: this.totalTime,
              times: this.times
            };
            const data = await editScaleAnswer(parmas);
            console.log(data);
            if (data.code == 0) {
              this.updaScaleAnswerSchedule();
            }
          }
        }
      }
      this.$message.success('答题完成');

      setTimeout(() => {
        this.$router.push({ name: 'grade' });
        this.showGrade = true;
      }, 500);
      // }
    },
    // 最后的提交进度
    async updaScaleAnswerSchedule() {
      let params = {
        studentId: this.studentId,
        times: this.times,
        schedule: '已完成'
      };
      try {
        const data = await updaScaleAnswerSchedule(params);
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },

    conversionTime() {
      let dateTime2 = new Date().getTime();
      let dateTime1 = sessionStorage.getItem('dateTime');
      let add = dateTime2 - dateTime1;
      this.totalTime = Math.floor((add / (1000 * 60)) % 60);
      if (this.totalTime == '0') {
        this.totalTime = 1;
      }
      sessionStorage.setItem('totalTime', this.totalTime);
      let dateTimeAll = new Date();
      let dateTimeAllShow2 =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      let dateTimeAllShow = sessionStorage.getItem('dateTimeAllShow');
      this.timeShow = dateTimeAllShow + ' - ' + dateTimeAllShow2;
      console.log(dateTimeAllShow);
      console.log(dateTimeAllShow2);
    },

    btnCancel() {
      this.showDialog = false;
    },
    // 退出登录
    logOut() {
      sessionStorage.clear();
      location.reload(); //重新加载
    },
    cutStudents() {
      this.$router.push({ name: 'student' });
      sessionStorage.removeItem('dateTime');
    },
    // 开始计时
    timerStart() {
      this.startTime = new Date().getTime();
    },
    // 结束计时
    timeOver() {
      this.overTime = new Date().getTime();
      this.everyTime = this.overTime - this.startTime;
    },
    // 开始答题
    async beginTesting(item, index) {
      // this.jump = true;
      this.timerStart();
      this.toNext(item, index);
      // this.scaleAnswerNextTimes(this.studentId);
      let dateTime = new Date().getTime();
      let dateTimeAll = new Date();
      let dateTimeAllShow =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      sessionStorage.setItem('dateTimeAllShow', dateTimeAllShow);
      sessionStorage.setItem('dateTime', dateTime);
    },

    // 跳到某一题
    selectChange(val) {
      this.toIndex(val - 1);
      // this.saveCur(item, index);
    },
    // 保存跳转之前的答案选项
    async selectBlur(item, index) {
      this.saveCur(item, index);
      if (this.questionList[index].name) {
        if (this.questionInfos[index].nums) {
          let exName = this.questionList[index].name;
          if (exName.search('练习') != -1) {
            console.log('不上传');
          } else {
            let maybe = JSON.parse(
              sessionStorage.getItem(this.questionList[index].name)
            );
            if (!maybe) {
              let parmas = {
                options: this.questionInfos[index].nums,
                scaleId: this.questionList[index].id,
                studentId: this.studentId,
                scaleName: this.questionList[index].name,
                timeSpent: this.everyTime,
                times: this.times
              };
              const res = await editScaleAnswer(parmas);
              if (res.code == 0) {
                let mapAll = { id: res.data, timeSpent: this.everyTime };
                sessionStorage.setItem(
                  this.questionList[index].name,
                  JSON.stringify(mapAll)
                );
              }
            } else {
              let obj = JSON.parse(
                sessionStorage.getItem(this.questionList[index].name)
              );
              let parmas = {
                options: this.questionInfos[index].nums,
                scaleId: this.questionList[index].id,
                studentId: this.studentId,
                id: obj.id,
                scaleName: this.questionList[index].name,
                timeSpent: obj.timeSpent + this.everyTime,
                times: this.times
              };
              let mapAll = { id: obj.id, timeSpent: parmas.timeSpent };
              sessionStorage.setItem(
                this.questionList[index].name,
                JSON.stringify(mapAll)
              );
              await editScaleAnswer(parmas);
            }
          }
        }
        this.timerStart();
      }
    },
    handleInput() {
      // 去除非数字字符
      this.selectValue = this.selectValue.replace(/[^\d]/g, '');

      // 限制输入长度为 10
      if (this.selectValue.length > 2) {
        this.selectValue = this.selectValue.slice(0, 2);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  margin: auto;
  // height: 100vh;
  background-color: #ffffff;
  padding: 100px;
  // background-color: #0a1531;
}
.btnSwitch {
  height: 50px;
  text-align: center;
  position: fixed;
  top: 90%;
  left: 50%;
  // margin-top: 70px;
  transform: translate(-50%, -50%);
}
.gradeDialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.gradeDialog_box1 {
  position: relative;
  .gradeDialog_box1_2 {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 70px;
    color: #ffffff;
    transform: translate(-50%, -50%);
  }
  .gradeDialog_box1_3 {
    position: absolute;
    top: 31%;
    left: 50%;
    font-size: 20px;
    color: #ffffff;
    transform: translate(-50%, -50%);
  }
}
.custom-select {
  width: 100px;
  margin: 0 10px;
}
.custom {
  margin-left: 10px;
}
</style>
